module.exports = __webpack_public_path__ + "static/media/FAQ.2c345fdf.svg";